/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Match_Analysis_FailedInputs */

const en_deep_match_analysis_failed = /** @type {(inputs: Deep_Match_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysis failed. Please try again.`)
};

const de_deep_match_analysis_failed = /** @type {(inputs: Deep_Match_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysis failed. Please try again.`)
};

const fr_deep_match_analysis_failed = /** @type {(inputs: Deep_Match_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysis failed. Please try again.`)
};

const es_deep_match_analysis_failed = /** @type {(inputs: Deep_Match_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysis failed. Please try again.`)
};

const it_deep_match_analysis_failed = /** @type {(inputs: Deep_Match_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysis failed. Please try again.`)
};

const nl_deep_match_analysis_failed = /** @type {(inputs: Deep_Match_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysis failed. Please try again.`)
};

const pl_deep_match_analysis_failed = /** @type {(inputs: Deep_Match_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysis failed. Please try again.`)
};

const fi_deep_match_analysis_failed = /** @type {(inputs: Deep_Match_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysis failed. Please try again.`)
};

const da_deep_match_analysis_failed = /** @type {(inputs: Deep_Match_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysis failed. Please try again.`)
};

const sv_deep_match_analysis_failed = /** @type {(inputs: Deep_Match_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysis failed. Please try again.`)
};

/**
* | output |
* | --- |
* | "Analysis failed. Please try again." |
*
* @param {Deep_Match_Analysis_FailedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_analysis_failed = /** @type {((inputs?: Deep_Match_Analysis_FailedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_Analysis_FailedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_analysis_failed(inputs)
	if (locale === "fr") return fr_deep_match_analysis_failed(inputs)
	if (locale === "es") return es_deep_match_analysis_failed(inputs)
	if (locale === "it") return it_deep_match_analysis_failed(inputs)
	if (locale === "nl") return nl_deep_match_analysis_failed(inputs)
	if (locale === "pl") return pl_deep_match_analysis_failed(inputs)
	if (locale === "fi") return fi_deep_match_analysis_failed(inputs)
	if (locale === "da") return da_deep_match_analysis_failed(inputs)
	if (locale === "sv") return sv_deep_match_analysis_failed(inputs)
	return en_deep_match_analysis_failed(inputs)
});